import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[uiPopupContentHost]',
    standalone: false,
})
export class PopupContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
